<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>视频监控</el-breadcrumb-item>
		</el-breadcrumb>
		<tool-bar v-on:select="handleSelectJT" :timerVisible="false" />
		<div class="monitor_section" v-if="showDeviceInfo">
			<div slot="header" class="clearfix" style="margin-bottom:20px;">
				<span>视频监控</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="handleFullScreen('defect_view1')">最大化</el-button>
			</div>
			
			<!-- <device-colo-status :class="{ view: istrue }" id="defect_view" :jt_id="selectedJT._id.$oid" :jt_status="selectedJT.statusInfo" /> -->
		</div>
		<div class="urlIframe"  ><iframe id="defect_view1" allowScriptAccess="sameDomain"  :src="token" frameborder="0" width="100%" class="iframeView"   ></iframe></div>
		
		<!-- <div id="divPlugin " class="plugin"></div> -->
	</div>
</template>
<script>
	// import { WebVideoCtrl } from '../../../static/webVideoCtrl.js'
	import { workshopRequest } from '@/network/requests/workshop'
	import maxwindous from './maxWindous.js'
	import ToolBar from './ToolBar'
	export default {
		name: 'videoew',
		mixins: [maxwindous],
		components: {
			ToolBar,
		},
		data() {
			return {
				token:'',
				hkvInfo: {
					ip: '', //海康威视摄像头/硬盘录像机的ip地址
					port: '80', //海康威视摄像头/硬盘录像机的端口
					username: 'admin', //海康威视摄像头/硬盘录像机的用户名
					password: 'luster123', //海康威视摄像头/硬盘录像机的密码
					channels: [], //海康威视摄像头/硬盘录像机的通道
				},
				loginStatus: false,
				checkView: false,
				winWidth: '100%',
				currentJT: '',
				fileId: '',
				mySelectWnd: 0, //当前选中的窗口
				g_bPTZAuto: false,
				iProtocol: 1,
				loginLoading: false,
				startPlayLoading: false,
				iStreamType: 1,
				bZeroChannel: false,
				iRtspPort: 0,
			}
		},
		watch: {
			fileId() {
				console.log('切换ip')
				// this.clickStopRealPlay()
				if (this.token) {
					// this.$message({message:"token值存在"})
					console.log("token值存在")
				} else {
					this.$message({
						type: 'error',
						message: '没有摄像机ip，请添加',
					})
				}
				// if(this.checkView){
				//   this.clickStopRealPlay()
				// }
			},
		},

		created: function() {
			workshopRequest.queryAll().then(res => {
				console.log('获取车间', res)
				this.workshops = res
			})
			// this.onLogin()
		},
		mounted: function() {
			// this.videoInitPlugin() // 初始化video界面
			// this.viedo()
		},		
		computed: {			
			winHeight() {
				var winHeightval = document.body.clientHeight - 500
				return winHeightval + 'px'
			},
			
		},
		methods: {
			// viedo(){
			//  var obj = 	document.getElementById('defect_view1')
			//  obj.click()
			// },
			handleSelectJT(jtInfo) {
				this.currentJT = jtInfo
				console.log('jt_infeo', jtInfo)
				this.token = jtInfo.url //切换Url使得 机台发生改变
				// this.loginPassword=jtInfo.password,  //这些字段需要数据库添加
				// this.loginUser = user
				this.showDeviceInfo = true
				this.fileId = this.currentJT._id
			},
		
			
		},
	}
</script>

<style scoped>
	.plugin {
		width: 100%;
	}
	.iframeView{
		/* position: relative; */
		/* overflow: hidden; */
		/* transform: scale(0.5); */
		height: 100%;
		width:100%;
		overflow: hidden;
		/* top:-200px; */
		
	}
	.urlIframe{
		text-align: center;
		height:600px;
		width: 600px;
		/* transform: scale(0.5); */
	}
	

	.my-tag {
		margin-left: 3px;
	}

	.my-group-btn {
		margin-top: 5px;
	}
</style>
